import { Movimiento } from 'core/tarjeta/models/Movimiento';
import { Table } from 'shared/table';
import { formatDate, formatCurrency } from 'shared/utils';

export const AccountAuthorizationTable = ({
  authorizations,
}: {
  authorizations: Movimiento[];
}) => {
  const printTipoTransaccion = (item: Movimiento) => {
    return item.tipoOperacion.detalle === 'CONSUMO PESOS'
      ? 'CONSUMO PESOS'
      : 'PAGO PESOS';
  };

  const montoTotal = () => {
    let total = 0;
    authorizations.forEach((item: Movimiento) => {
      total += item.importe;
    });
    return total;
  };

  return (
    <Table
      thead={
        <tr>
          <td>Tarjeta</td>
          <td>Fecha</td>
          <td>Establecimiento</td>
          <td>Importe</td>
          <td>Tipo de transacción</td>
        </tr>
      }
      tbody={
        <>
          {authorizations?.map((item, index) => (
            <tr
              key={'autorizacion' + item.tarjeta.numero}
              data-testid={'autorizacion-row-' + index}
            >
              <td>{item.tarjeta.numero}</td>
              <td>{formatDate(item.fecha)}</td>
              <td className="align-left">{item.establecimiento.nombreFantasia}</td>
              <td className="align-right">{formatCurrency(item.importe)}</td>
              <td className="align-left">{printTipoTransaccion(item)}</td>
            </tr>
          ))}
        </>
      }
      tfoot={
        <tr>
          <td colSpan={3}></td>
          <td>{formatCurrency(montoTotal())}</td>
          <td></td>
        </tr>
      }
    ></Table>
  );
};
